export default {"categories":"tigWA","sportFilter":"_5YjO-","pill":"E-mGC","active":"Ldzhn"};